// http://embla.ditmer.zone/#group-components-component-modals
import * as React from 'react';
import { Button } from '../bootstrap-components/BootstrapComponents';

export interface ModalProps {
    children?: any;
    id: string;
    alert?: boolean;
    modalSize?: 'lg' | 'sm';    
    title?: string;
    text?: any;
    excludeCancel?: boolean;
    className?: string;
}

export function Modal (props: ModalProps) {
    let modalStyle = '';
    if (props.alert !== undefined && props.alert) {
        modalStyle = ' modal-alert';
    }

    let modalDialogStyle = '';
    if (props.modalSize !== undefined) {
        modalDialogStyle = ' modal-' + props.modalSize;
    }    

    let modalClasses = 'modal fade' + modalStyle;
    let modalDialogClasses = 'modal-dialog' + modalDialogStyle;    

    let title = undefined;
    if (props.title !== undefined) {
        title = <h4 className='modal-title' id=''>{props.title}</h4>;
    }
    
    let cancelButton = undefined;
    if (props.excludeCancel === undefined || !props.excludeCancel) {
        cancelButton = <Button buttonType='secondary' dataDismiss='modal'>Fortryd</Button>;
    }
    
    if (props.className !== undefined) {
        modalClasses += ' ' + props.className;
    }
    
    return (
        <div className={modalClasses} id={props.id} tabIndex={-1} role='dialog' aria-labelledby=''>
            <div className={modalDialogClasses} role='document'>
                <div className='modal-content'>
                <div className='modal-header'>
                    <button type='button' className='close' data-dismiss='modal' aria-label='Close'><span aria-hidden='true'>&times;</span></button>
                    {title}
                </div>
                <div className='modal-body'>
                    {props.text}
                </div>
                <div className='modal-footer'>
                    {cancelButton}
                    {props.children}
                </div>
                </div>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/layout/Modal.tsx